/**
 * SIR Credits — read-only reference table (right column). System rates
 * from the real `/v2/credit-factors/sir` backend (via `useSirCredits`),
 * NOT user inputs: editing happens in a separate Rates page (TBD), so the
 * percent fields render disabled.
 */
import { Shield01 } from "@untitledui/icons";
import { FormGroup } from "../../../../components/form-group";
import { PercentInput } from "../../../../components/percent-input";
import { Skeleton } from "../../../../components/skeleton";
import { useSirCredits } from "../../../../hooks/use-sir-credits";
import { CardRows } from "../components/field-row";

function formatRetention(n: number): string {
    return `$${n.toLocaleString("en-US")}`;
}

export function SirCreditsCard() {
    const state = useSirCredits();

    return (
        <FormGroup title="SIR Credits" icon={Shield01} data-autotest="premium-selection-sir-credits-card">
            <CardRows>
                {state.status === "ready" ? (
                    state.data.map((tier) => (
                        <div key={tier.retention} className="flex min-h-15 items-center justify-between gap-4 py-3">
                            <span className="text-secondary text-sm font-medium">{formatRetention(tier.retention)}</span>
                            <div className="w-24 shrink-0 cursor-not-allowed">
                                <PercentInput
                                    aria-label={`SIR credit for ${formatRetention(tier.retention)}`}
                                    value={String(Number((tier.credit * 100).toFixed(2)))}
                                    isDisabled
                                />
                            </div>
                        </div>
                    ))
                ) : state.status === "error" ? (
                    <div className="text-tertiary py-2 text-sm">Couldn't load SIR credits.</div>
                ) : (
                    <div className="flex flex-col gap-3 py-1">
                        {Array.from({ length: 7 }).map((_, i) => (
                            <div key={i} className="flex items-center justify-between gap-4">
                                <Skeleton className="h-4 w-20" />
                                <Skeleton className="h-8 w-24" />
                            </div>
                        ))}
                    </div>
                )}
            </CardRows>
        </FormGroup>
    );
}
